import styled from 'styled-components'

import { Scroll } from 'styles/Helpers'

export const TabsWrapper = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacings[6]};
  max-height: ${({ theme }) =>
    `calc(100vh - ${theme.misc.header.height} - 2 * ${theme.spacings[6]})`};
`

export const TabListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  border-radius: 8px 0px 0px 8px;
  overflow: hidden;
  height: fit-content;
  min-width: 240px;

  border: 1px solid #d8d8d877;
  border-right: none;
`

type TabContainerProps = {
  isSelected: boolean
  small: boolean
}

export const TabContainer = styled.li<TabContainerProps>`
  display: inline-block;
  position: relative;

  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.primary : '#989898'};
  background-color: ${({ isSelected }) => (isSelected ? 'white' : '#F3F3F3')};
  border-left: ${({ isSelected, theme }) =>
    isSelected
      ? `10px solid ${theme.colors.primary}`
      : '10px solid transparent'};

  &[data-marker]:not([data-marker='']) {
    &::after {
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: ${({ theme }) => theme.fontSizes.xsm};
      font-weight: bold;

      content: attr(data-marker);

      position: absolute;
      top: 12px;
      right: ${({ theme }) => theme.spacings[4]};

      height: 16px;
      width: 16px;

      border-radius: 50%;

      line-height: 0;

      color: white;
      background-color: #3fa73a;
    }
  }

  button {
    height: 40px;
    width: 100%;
    padding-left: 14px;

    font-family: BloggerSans, sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    text-transform: uppercase;
    text-align: left;

    color: inherit;
  }
`

export const TabPanelContainer = styled.section`
  width: 100%;
  /* padding: ${({ theme }) => theme.spacings[6]}; */

  border-radius: 0px 10px 10px 10px;
  background-color: white;

  border: 1px solid #d8d8d877;

  ${Scroll}
`
